exports.area = function(radius){
    //alert('hi');
    return 3.14*radius*radius;
}


//////////////////
// WEBPACK FOOTER
// ./src/~/demo.js
// module id = 1622
// module chunks = 18